import { useMutation } from '@tanstack/react-query';
import WidgetApiV2 from '../../lib/api/widget/WidgetApiV2';
import useRedirect from '../common/useRedirect';
import { WIDGET_ALL_LIST_URL_PATH } from '../../constants/service/common/urlConstants';
import toastMsg from '../../lib/toastMsg';
import { ErrorResponseType, extractErrorMessage } from '../../lib/utils/checkErrorResponse';
import { EventWidgetRequestPayloadV2, WIDGET_TYPE_V2, WidgetRequestPayload } from '../../types/widget';
import { confirmWidgetPeriod } from '../../lib/utils/widget/confirmWidgetPeriod';

interface UseCreateWidgetReturnType {
  createWidget: (payload: { type: WIDGET_TYPE_V2; widget: WidgetRequestPayload }) => void;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
}

const useCreateWidget = (): UseCreateWidgetReturnType => {
  const redirect = useRedirect();
  const { mutate, isSuccess, isLoading, isError } = useMutation(WidgetApiV2.createWidget, {
    onSuccess: () => redirect(WIDGET_ALL_LIST_URL_PATH),
    onError: (error: ErrorResponseType) => toastMsg.error(extractErrorMessage(error)),
  });

  const createWidget = async (payload: { type: WIDGET_TYPE_V2; widget: WidgetRequestPayload }): Promise<void> => {
    const widget = payload.widget;
    const isEventWidget = widget instanceof EventWidgetRequestPayloadV2;

    const confirmResult = await confirmWidgetPeriod({
      startDate: isEventWidget ? null : widget.exposureStartDate,
      endDate: isEventWidget ? null : widget.exposureEndDate,
    });

    if (confirmResult) mutate(payload);
  };

  return {
    createWidget,
    isLoading,
    isSuccess,
    isError,
  };
};

export default useCreateWidget;
